import React from 'react';

import cx from '../../utils/classNames';
import toCamelCase from '../../utils/toCamelCase';

import styles from './filterChip.module.scss';

import type { MouseEvent, MouseEventHandler, ReactNode } from 'react';

type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
  /** When true, makes the element not mutable, focusable, or submitted with the form */
  isDisabled?: boolean;
  /** If true, the filter is selected */
  isSelected?: boolean;
  /** Calls a function when the filterChip is clicked */
  onClick?: (
    value: string | number | undefined,
    event: MouseEvent<HTMLButtonElement>,
  ) => void | MouseEventHandler<HTMLButtonElement>;
  /** Value of the filter chip */
  value?: string | number;
  /** Size of the filter chip */
  size?: 'small' | 'medium';
};

export function FilterChip(props: Props) {
  const {
    children,
    className,
    isSelected = false,
    isDisabled,
    onClick,
    size = 'medium',
    value,
  } = props;

  const classNames = cx(
    styles.filterChip,
    isSelected
      ? styles[toCamelCase('filterChip', 'selected')]
      : styles[toCamelCase('filterChip', 'unselected')],
    styles[toCamelCase('filterChip', size)],
    className,
  );

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    onClick?.(value, event);
  };

  return (
    <button className={classNames} disabled={isDisabled} onClick={handleClick} type="button">
      {children}
    </button>
  );
}

export default FilterChip;
